import { requiredRule, getRuleLen, phoneRule, emailRule } from '../../../../utils/rules';
import React from 'react';
import { Form, Input } from '@roo/roo';

const { Field } = Form;

export const Person = function () {
  return (
    <div className='form-patch'>
      <Field
        required={true}
        rule={getRuleLen(20, true)}
        name={`name`}
        label='姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名'
        as={<Input maxLength={20} placeholder={'请输入联系人的真实姓名'} />}
      />
      <Field
        required={true}
        rule={getRuleLen(20, true)}
        name={`job`}
        label='职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位'
        as={<Input maxLength={20} placeholder={'请输入联系人的职务名称，需要在主申报机构任职'} />}
      />
      <Field
        required={true}
        rule={{ ...phoneRule }}
        name={`phone`}
        label='手机号码'
        as={<Input maxLength={50} placeholder={'请输入常用手机号码，并保存畅通'} />}
      />
      <Field
        required={true}
        rule={{ ...emailRule }}
        name={`email`}
        label='联系邮箱'
        as={<Input maxLength={50} placeholder={'请输入联系邮箱，我们会发送重要通知'} />}
      />
      <br />
    </div>
  );
};
